/* eslint-disable*/

import Vue from 'vue'
import VueRouter from 'vue-router'

import shared from './shared'

const router = shared.getRouter()

//add router and ui components
Vue.use(VueRouter)

//mount vue to base <div>
window.app = new Vue({
  el: '#app',
  router,
  template: '<router-view/>'
})



// WEBPACK FOOTER //
// ./src/main.js